module.exports = {
  familyName: 'Roboto',
  category: 'sans-serif',
  capHeight: 1456,
  ascent: 1900,
  descent: -500,
  lineGap: 0,
  unitsPerEm: 2048,
  xHeight: 1082,
  xWidthAvg: 905
};
